<template>
  <div class="wrapper" v-bind:class='{navopen:isActive01}'>

    <header>

      <div class="inner_header flex between" :class="{ non_fixed: scrollPosition < 100, is_fixed: scrollPosition > 100 }">


<!--        <div class="q-pa-md q-gutter-sm wrap_breadcrumbs">-->

<!--          <q-breadcrumbs gutter="sm">-->
<!--            <q-breadcrumbs-el label="HOME" to="https://www.j-reve.co.jp/" />-->
<!--            <q-breadcrumbs-el label="WORKS" />-->
<!--          </q-breadcrumbs>-->

<!--        </div>-->

        <picture class="logo_header">
          <a href="https://www.j-reve.co.jp/">
            <source media="(min-width: 768px)" srcset="../assets/images/common/logo_header.svg">
            <source media="(max-width: 767px)" srcset="../assets/images/common/logo_header.svg">
            <img src="../assets/images/common/logo_header.svg" alt="logo Reve">
          </a>
        </picture>


        <nav class="nav_header flex">
          <ul class="nav_header-list flex">
            <li class="nav_header-item">
              <a href="https://j-reve.co.jp/#sec_concept" class="font_ltc bold">
                CONCEPT
              </a>
            </li>
            <li class="nav_header-item">
              <a href="https://j-reve.co.jp/#sec_service" class="font_ltc bold">
                SERVICE
              </a>
            </li>
            <li class="nav_header-item">
              <a href="https://j-reve.co.jp/#sec_consulting" class="font_ltc bold">
                CONSULTING
              </a>
            </li>
            <li class="nav_header-item">
              <a href="" class="font_ltc bold active">
                WORKS
              </a>
            </li>
            <li class="nav_header-item">
              <a href="https://j-reve.co.jp/#sec_company" class="font_ltc bold">
                COMPANY
              </a>
            </li>
            <li class="nav_header-item">
              <a href="https://www.j-reve.co.jp/contact.html" class="font_ltc bold">
                CONTACT
              </a>
            </li>
          </ul>
        </nav>
      </div>


      <div class="header-sp">
        <nav class="global-nav">
          <ul class="global-nav__list">
            <li class="global-nav__item"><a href="https://www.j-reve.co.jp/index.html#sec_concept">CONCEPT</a></li>
            <li class="global-nav__item"><a href="https://www.j-reve.co.jp/index.html#sec_service">SERVICE</a></li>
            <li class="global-nav__item"><a href="https://www.j-reve.co.jp/index.html#sec_consulting">CONSULTING</a></li>
            <li class="global-nav__item"><a href="https://www.j-reve.co.jp/works/">WORKS</a></li>
            <li class="global-nav__item"><a href="https://www.j-reve.co.jp/index.html#sec_company">COMPANY</a></li>
            <li class="global-nav__item"><a href="https://www.j-reve.co.jp/contact.html">CONTACT</a></li>
          </ul>
        </nav>
        <!-- <div class="hamburger" id="js-hamburger" v-on:click='isActive01=!isActive01'>
          <span class="hamburger__line hamburger__line--1"></span>
          <span class="hamburger__line hamburger__line--2"></span>
          <span class="hamburger__line hamburger__line--3"></span>
        </div> -->
        <div class="black-bg" id="js-black-bg"></div>
      </div>

      <!-- sp button -->
      <div id="hamburger" class="hamburglar" v-on:click='isActive01=!isActive01, isActive02=!isActive02'  v-bind:class='{is_open:isActive02}'>
      
        <div class="burger-icon">
          <div class="burger-container">
            <span class="burger-bun-top"></span>
            <span class="burger-filling"></span>
            <span class="burger-bun-bot"></span>
          </div>
        </div>

        <div class="burger-ring">
          <svg class="svg-ring">
            <path class="path" fill="none" stroke="#014998" stroke-miterlimit="10" stroke-width="4"
              d="M 34 2 C 16.3 2 2 16.3 2 34 s 14.3 32 32 32 s 32 -14.3 32 -32 S 51.7 2 34 2" />
          </svg>
        </div>
      
        <svg width="0" height="0">
          <mask id="mask">
            <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#014998" stroke-miterlimit="10" stroke-width="4"
              d="M 34 2 c 11.6 0 21.8 6.2 27.4 15.5 c 2.9 4.8 5 16.5 -9.4 16.5 h -4" />
          </mask>
        </svg>
        <div class="path-burger">
          <div class="animate-path">
            <div class="path-rotation"></div>
          </div>
        </div>
      </div>
      
    </header>


    <div class="container">
      <q-layout view="lHh Lpr lFf">
        <q-page-container>
          <router-view />
        </q-page-container>
      </q-layout>
    </div>

    <footer>
      <div class="inner_footer" id="sec_contact">

        <h2 class="title_contact">
          お問い合わせはこちらから
        </h2>

        <div class="wrap_btn_contact">
          <div class="flex between btn_contact">
            <a href="tel:0663357576" class="btn_base blue btn buttonX">
							<span class="text_btn">
								TEL 06-6335-7576
							</span>
            </a>
            <a href="../contact.html" class="btn_base yellow  btn buttonX">
							<span class="text_btn">
								CONTACT
							</span>
            </a>
          </div>
          <p class="text_note_contact">
            営業時間： 平日10時～18時(土日祝休み)
          </p>
        </div>

        <picture class="logo_footer">
          <a href="./">
            <source media="(min-width: 768px)" srcset="../assets/images/common/logo_footer.svg">
            <source media="(max-width: 767px)" srcset="../assets/images/common/logo_footer.svg">
            <img src="../assets/images/common/logo_header.svg" alt="logo Reve">
          </a>
        </picture>

        <div class="text_adress">
          日本レーヴ株式会社 〒532-0003 大阪府大阪市淀川区宮原1-19-23
        </div>

      </div>

      <p class="text_copyright">
        <small>&copy; 2019 REVE CO.LTD. All right reserved.</small>
      </p>
    </footer>


  </div>
</template>

<style lang="scss">
  @import "../assets/style/common.scss";
  .wrapper {
    // background-image: url('../assets/images/common/contents_bg2.jpg');
    // background-repeat: repeat;
  }
  .container {
    max-width: 1800px;
    margin-right: auto;
    margin-left: auto;
  }
  .q-layout__section--marginal {
    background: none;
  }
  .q-layout__section--marginal {
    background-color: transparent !important;
  }
  //for header
  .q-header {
    background-color: #2d2d2d4f !important;
  }
  .q-layout__shadow:after {
    display: none;
  }
  .q-item__section--side {
    min-width: 1px !important;
    padding-right: 0 !important;
    i {
      margin-right: 7px;
    }
  }
  //
  .desktop {
    .q-header {
      display: none;
    }
  }
  //
  .q-panel > div {
    background-color: #fffdfb;
    background-image: url('../assets/images/common/contents_bg0.svg');
    background-repeat: repeat;
  }

  // ---------------------------------------------------------
  // header
  // ---------------------------------------------------------
  header {
    position: fixed;
    z-index: 9000;
    top: 0;
    left: 0;
    width: 100%;
  }

  .inner_header {
    height: auto;
    //
    transition:background-color 1s linear 0s,
    height 2s linear 0s;
    &.non_fixed {
      .nav_header-item {
        a {
          color: #fff;
          &.active {
            border-bottom-color: #fff;
            border-bottom-width: 1px;
          }
        }
      }
    }
  }

  .inner_header.is_fixed {
    // height: 50px;
    background-color: #fff;
    .nav_header {
      padding-top: 0;
    }
  }

  @media only screen and (max-width: 767px) {
    .inner_header.is_fixed {
      height: 40px;
    }
  }

  // .is_fixed:after {
  //   opacity: 0;
  //   //
  //   transition:background-color 1s linear 0s,
  //   height 2s linear 0s;
  // }

  // .inner_header.is_fixed:after {
  //   opacity: 1;
  // }

  .logo_header {
    display: block;
    padding: .8% 0 0 5.45%;
    @media only screen and (max-width: 767px) {
      position: relative;
      z-index: 9001;
      top: 12px;
      left: 5px;
      padding-top: 1%;
      padding-left: 1%;
    }
    img {
      width: 120px;
      @media only screen and (max-width: 767px) {
        width: 85px;
      }
    }
  }

  .logo_header_scroll {
    display: none;
    position: relative;
    top: 6px;
    padding-left: 5.5%;
    img {
      width: 90px;
    }
  }

  @media only screen and (max-width: 767px) {
    .logo_header_scroll {
      padding-left: 1.5%;
      img {
        width: 76px;
      }
    }
  }

  .is_fixed .logo_header_scroll {
    display: block;
  }

  // .is_fixed .logo_header {
  //   display: none;
  // }

  .is_fixed {
    // .logo_header {
    //   padding: 10px 0 0 2.5%;
    //   img {
    //     width: 80px;
    //     //
    //     @media only screen and (max-width: 767px) {
    //       width: 85px;
    //     }
    //   }
    // }
  }

  .nav_header {
    width: 100%;
    padding-top: 1%;
    padding-right: 3%;
    //
    transition:background-color 1s linear 0s,
    height 2s linear 0s;
    @media only screen and (max-width: 767px) {
      display: none !important;
    }
  }

  .nav_header-list {
    position: relative;
    top: 12px;
    align-self: center;
    justify-content: flex-end;
    width: 100%;
  }

  .nav_header-item {
    &:not(:last-child) {
      margin-right: 2.5%;
    }
    a {
      position: relative;
      color: #014998;
      //
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5;
      letter-spacing: .01em;
      text-align: justify;
      text-justify: inter-ideograph;
      //
      white-space: nowrap;
    }
  }



  $menu-underline-from-center-bg: #2C3840;
  $menu-underline-from-center-border-thickness: 0.125rem;

  .nav_header {
    display: flex;
    justify-content: center;
    .nav_header-list {
      display: inline-flex;
      list-style-type: none;
      .nav_header-item {
        list-style: none;
      }
      a {
        padding-bottom : 3px;
        border-bottom : 1px dotted rgba(255, 255, 255, 0.15);
        //
        text-decoration: none;
        opacity: 0.8;
        -webkit-transition: color 0.5s ease;
        transition: 1.0s;

        border-bottom-style: solid;
        border-bottom-color: transparent;
        border-bottom-width: 1px;

        &:hover,
        &.active {
          border-bottom-color: #014998;
          border-bottom-width: 1px;
        }
      }
    }
  }

  @keyframes hover {
    0% {
      color: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  .inner_header {
    flex-wrap: nowrap !important;
    padding-top: .5%;
    padding-right: 2.8%;
    transition: .3s;
    @media only screen and (max-width: 767px) {
      display: block !important;
    }
  }

  .is_fixed {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100% !important;
    opacity: 1;
    //
    // &:after {
    //   content: '';
    //   position: absolute;
    //   z-index: -1;
    //   top: 0;
    //   left: 0;
    //   //
    //   width: 100%;
    //   height: 100%;
    //   //
    //   /*background-color: #fff !important;*/
    //   /*background-color: #ffffffd6 !important;*/
    //   //
    //   transition: 1.2s;
    //   transition-timing-function:linear;
    // }
    .nav_header-list {
      top: 0;
      z-index: 9999;
    }
  }

  .is-hide {
    transform: translateY(-100%);
  }


  // ---------------------------------------------------------
  // sp-header
  // ---------------------------------------------------------
  .header-sp {
    display: none;
    //
    position: fixed;
    z-index: 200;
    left: 0;
    top: 0;
    width: 100%;
    height: 76px;
    background-color: #fff;
    // box-shadow: 0 2px 6px rgba(0, 0, 0, .16);
    @media only screen and (max-width: 767px) {
      display: block;
    }
  }

  .global-nav {
    position: fixed;
    right: -320px;
    top: 0;
    width: 280px;
    height: 100vh;
    padding-top: 100px;
    background-color: #fff;
    background-color: #ffffffd1;
    transition: all .6s;
    z-index: 200;
    overflow-y: auto;
  }

  .hamburger {
    position: absolute;
    right: 0;
    top: 4px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 300;
  }

  .global-nav__list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .global-nav__item {
    padding: 0 20px;
    background-color: #eeeeee1c;
    text-align: left;
  }

  .global-nav__item a {
    display: block;
    padding: 8px 10px;
    border-bottom: 1px dotted #003e8240;
    text-decoration: none;
    color: #111;
  }

  .global-nav__item a:hover {
    background-color: #eee;
  }

  .hamburger__line {
    position: absolute;
    z-index: 10;
    left: 11px;
    width: 22px;
    height: 2px;
    background-color: #004898;
    transition: all .6s;
  }

  .hamburger__line--1 {
    top: 14px;
  }

  .hamburger__line--2 {
    top: 20px;
  }

  .hamburger__line--3 {
    top: 26px;
  }

  .black-bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    background-color: #000;
    background-color: #0000002e;
    opacity: 0;
    visibility: hidden;
    transition: all .6s;
    cursor: pointer;
  }

  /* 表示された時用のCSS */
  .navopen .global-nav {
    right: 0;
  }

  .navopen .black-bg {
    opacity: .8;
    visibility: visible;
  }

  .navopen .hamburger__line--1 {
    transform: rotate(45deg);
    top: 20px;
  }

  .navopen .hamburger__line--2 {
    width: 0;
    left: 50%;
  }

  .navopen .hamburger__line--3 {
    transform: rotate(-45deg);
    top: 20px;
  }








  // vars
$color: rgb(11, 0, 112); // icon color
$blue: #158fef; // background color
$animation: 0.6s; // animation speed
$scale: 1; // icon scale 68/68 default

/* -----------------------------------------------------------
	sp menu
----------------------------------------------------------- */
#hamburger {
  z-index: 9010;
  display: none;
  @media only screen and (max-width: 767px) {
    display: block;
  }
}

.hamburglar {
  transform: scale($scale);
  position: fixed;
  top: 5px;
  right: 5px;
  z-index: 9002;
  display: block;
  width: 68px;
  height: 68px;
  -webkit-touch-callout: none;
  user-select: none;

  &:hover {
    cursor: pointer;
  }
}

// transition mask
.path-burger {
  position: absolute;
  top: 0;
  left: 0;
  height: 68px;
  width: 68px;
  // two masks because... browser support.
  mask: url(#mask);
  -webkit-mask-box-image: url('https://raygun.io/upload/mask.svg');
}

.animate-path {
  position: absolute;
  top: 0;
  left: 0;
  width: 68px;
  height: 68px;
}

// what this does is create a small square that I then rotate behind an svg mask, giving the apparence of the line animating
.path-rotation {
  height: 34px;
  width: 34px;
  margin: 34px 34px 0 0;
  transform: rotate(0deg);
  transform-origin: 100% 0;

  &:before {
    content: '';
    display: block;
    width: 30px;
    height: 34px;
    margin: 0 4px 0 0;
    background: $color;
  }
}

// box rotation animation
@keyframes rotate-out {
  0% {
    transform: rotate(0deg);
  }

  40% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate-in {
  0% {
    transform: rotate(360deg);
  }

  40% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

// offset moves
// dasharray is the dash size
// need to be able to control dash space size.

.hamburglar.is_open {
  .path {
    animation: dash-in $animation linear normal;
    animation-fill-mode: forwards;
  }

  .animate-path {
    animation: rotate-in $animation linear normal;
    animation-fill-mode: forwards;
  }
}

.hamburglar {
  .path {
    animation: dash-out $animation linear normal;
    animation-fill-mode: forwards;
  }

  .animate-path {
    animation: rotate-out $animation linear normal;
    animation-fill-mode: forwards;
  }
}

.path {
  stroke-dasharray: 240;
  stroke-dashoffset: 240;
  stroke-linejoin: round;
}

@keyframes dash-in {
  0% {
    stroke-dashoffset: 240;
  }

  40% {
    stroke-dashoffset: 240;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash-out {
  0% {
    stroke-dashoffset: 0;
  }

  40% {
    stroke-dashoffset: 240;
  }

  100% {
    stroke-dashoffset: 240;
  }
}



// All good burgers need filling!

.burger-icon {
  position: absolute;
  padding: 20px 16px;
  height: 68px;
  width: 68px;
}

.burger-container {
  position: relative;
  height: 28px;
  width: 36px;
}

.burger-bun-top,
.burger-bun-bot,
.burger-filling {
  position: absolute;
  display: block;
  height: 4px;
  width: 36px;
  border-radius: 2px;
  background: $color;
}

.burger-bun-top {
  top: 0;
  transform-origin: 34px 2px;
}

.burger-bun-bot {
  bottom: 0;
  transform-origin: 34px 2px;
}

//.burger-filling {
//  @include transition(all,($animation/2.5),ease-in-//out);
//}
// relative parent is the button
.burger-filling {
  top: 12px;
}





// burger ring container
.burger-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 68px;
  height: 68px;
}

.svg-ring {
  width: 68px;
  height: 68px;
}


// bun animations 
.hamburglar.is_open {
  .burger-bun-top {
    animation: bun-top-out $animation linear normal;
    animation-fill-mode: forwards;
  }

  .burger-bun-bot {
    animation: bun-bot-out $animation linear normal;
    animation-fill-mode: forwards;
  }
}

.hamburglar {
  .burger-bun-top {
    animation: bun-top-in $animation linear normal;
    animation-fill-mode: forwards;
  }

  .burger-bun-bot {
    animation: bun-bot-in $animation linear normal;
    animation-fill-mode: forwards;
  }
}

@keyframes bun-top-out {
  0% {
    left: 0;
    top: 0;
    transform: rotate(0deg);
  }

  20% {
    left: 0;
    top: 0;
    transform: rotate(15deg);
  }

  80% {
    left: -5px;
    top: 0;
    transform: rotate(-60deg);
  }

  100% {
    left: -5px;
    top: 1px;
    transform: rotate(-45deg);
  }
}

@keyframes bun-bot-out {
  0% {
    left: 0;
    transform: rotate(0deg);
  }

  20% {
    left: 0;
    transform: rotate(-15deg);
  }

  80% {
    left: -5px;
    transform: rotate(60deg);
  }

  100% {
    left: -5px;
    transform: rotate(45deg);
  }
}


@keyframes bun-top-in {
  0% {
    left: -5px;
    bot: 0;
    transform: rotate(-45deg);
  }

  20% {
    left: -5px;
    bot: 0;
    transform: rotate(-60deg);
  }

  80% {
    left: 0;
    bot: 0;
    transform: rotate(15deg);
  }

  100% {
    left: 0;
    bot: 1px;
    transform: rotate(0deg);
  }
}

@keyframes bun-bot-in {
  0% {
    left: -5px;
    transform: rotate(45deg);
  }

  20% {
    left: -5px;
    bot: 0;
    transform: rotate(60deg);
  }

  80% {
    left: 0;
    bot: 0;
    transform: rotate(-15deg);
  }

  100% {
    left: 0;
    transform: rotate(0deg);
  }
}


// burger filling
.hamburglar.is_open {
  .burger-filling {
    animation: burger-fill-out $animation linear normal;
    animation-fill-mode: forwards;
  }
}

.hamburglar {
  .burger-filling {
    animation: burger-fill-in $animation linear normal;
    animation-fill-mode: forwards;
  }
}

@keyframes burger-fill-in {
  0% {
    width: 0;
    left: 36px;
  }

  40% {
    width: 0;
    left: 40px;
  }

  80% {
    width: 36px;
    left: -6px;
  }

  100% {
    width: 36px;
    left: 0px;
  }
}

@keyframes burger-fill-out {
  0% {
    width: 36px;
    left: 0px;
  }

  20% {
    width: 42px;
    left: -6px;
  }

  40% {
    width: 0;
    left: 40px;
  }

  100% {
    width: 0;
    left: 36px;
  }
}


  // ---------------------------------------------------------
  // footer
  // ---------------------------------------------------------
  footer {
    /*margin-top: 80px;*/
    color: #014998;
  }

  .inner_footer {
    padding: 2% 5% 1.6%;
    border-bottom: 1px solid #004998;
    //
    @media only screen and (max-width: 767px) {
      padding: 6.6% 5% 1.6%;
    }
  }

  .wrap_btn_contact {
    display: table;
    margin-right: auto;
    margin-left: auto;
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }

  .title_contact {
    margin-bottom: 36px;
    color: #014998;
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: .05em;
    text-align: center;
    text-justify: inter-ideograph;

    font-family: 游明朝, "Yu Mincho", YuMincho, "Hiragino Mincho ProN", "Hiragino Mincho Pro", HGS明朝E, メイリオ, Meiryo, serif;
  }

  .btn_contact {
    max-width: 1000px;
    border-radius: 5px;
    @media only screen and (max-width: 767px) {
      flex-direction: column;
      width: 100%;
    }
  }

  .logo_footer {
    display: table;
    margin-top: 45px;
    margin-right: auto;
    margin-left: auto;
    img {
      width: 179px;
      @media only screen and (max-width: 767px) {
        width: 132px;
      }
    }
  }

  //text
  .title_contact {
    margin-bottom: 36px;
    //
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: .05em;
    text-align: center;
    text-justify: inter-ideograph;
    //
    @media only screen and (max-width: 767px) {
      margin-bottom: 16px;
      //
      font-size: 20px;
    }
  }

  .text_note_contact {
    margin-top: 10px;
    //
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: .05em;
    text-align: left;
    text-justify: inter-ideograph;
    @media only screen and (max-width: 767px) {
      //
      font-size: 13px;
    }
  }

  .text_adress {
    display: block;
    margin-top: 18px;
    //
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: .02em;
    text-align: center;
    text-justify: inter-ideograph;
    //
    @media only screen and (max-width: 767px) {
      //
      font-size: 12px;
    }
  }

  .text_copyright {
    margin: 18px 0 0;
    padding: 0 0 18px;
    //
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: .07em;
    text-align: center;
    text-justify: inter-ideograph;
    @media only screen and (max-width: 767px) {
      //
      font-size: 10px;
    }
  }

  .btn:focus {
    outline: none;
  }

  .no-js .actions {
    display: none;
  }

  /* core */
  .btn {
    border: none;
    padding: 0.6em 1.2em;
    background: #004898;
    color: #fff;
    font-size: 21px;
    letter-spacing: 1px;
    text-transform: uppercase;
    cursor: pointer;
    display: inline-block;
    margin: 0;
    text-decoration: none;
    //
    position: relative;
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    border: 2px solid transparent;
    box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.12);
    transition: 250ms ease-out;
    font-size: 18px;
    padding: 1.05rem 2.13rem;
    border-radius: 3px;
    white-space: normal !important;
    word-wrap: break-word;
    cursor: pointer;
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }

  .btn + .btn {
    margin-left: 10px;
    @media only screen and (max-width: 767px) {
      margin-top: 10px;
      margin-left: 0;
    }
  }

  .btn:hover {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.22);
  }

  .btn span,
  .btn::after {
    color: #fff;
    position: relative;
    z-index: 1;
  }

  .btn::before {
    content: "";
    position: absolute;
    display: block;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    top: -1px;
    left: -1px;
    background: #f5f5ff;
  }

  .btn_base {
    display: block;
    width: calc((100% / 2) - 20px);
    min-width: 300px;
    padding: 3% 4%;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: .05em;
    text-justify: inter-ideograph;
    //
    @media only screen and (max-width: 767px) {
      width: 100%;
      margin-bottom: 0;
    }
    &:not(:first-child) {
      margin-left: 40px;
      @media only screen and (max-width: 767px) {
        margin-left: 0;
      }
    }
    &.blue {
      background-color: #004898;
      color: #fff;
    }
    &.yellow {
      background-color: #D2BE50;
      color: #004898;
      &:hover {
        span {
          color: #D2BE50 !important;
        }
      }
    }
  }

  /* custom */
  .col1 {
    border-color: #anycolor;
  }

  .col2 {
    border-color: #anycolor;
  }

  .buttonX::before {
    background: #fff;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.2s ease-out;
  }

  .buttonX.blue:hover span {
    color: #004898;
  }

  .buttonX.yellow:hover span {
    color: #004898;
  }

  .buttonX:hover::before {
    transform: scaleX(1);
    transform-origin: left;
  }


  /* -----------------------------------------------------------
      animation
  ----------------------------------------------------------- */
  @keyframes bg_move01 {
    0% {
      background-position: 0 -40px;
      background-size: 120% auto;
    }

    100% {
      background-position: 0 0;
      background-size: 140% auto;
    }
  }

  .animateOnce {
    -webkit-animation: bg_move01 2s ease-in-out normal forwards;
    -moz-animation: bg_move01 2s ease-in-out normal forwards;
    -o-animation: bg_move01 2s ease-in-out normal forwards;
  }

  //horizontal
  $color-main: #eee;
  $color-main-2: #D2BE50;

  .has-animation {
    position: relative;
    //
    h1,
    h2,
    h3,
    p,
    ul,
    img {
      opacity: 0;
    }
    //
    &.animate-in {
      h1,
      h2,
      h3,
      p,
      ul,
      img {
        animation: textHidden 0.1s 1.1s forwards;
      }
      //
      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        z-index: 10;
      }

      &:before {
        background-color: $color-main;
      }

      &:after {
        background-color: $color-main-2;
        animation-delay: .5s;
      }
    }

    &.animation-ltr.animate-in {
      &:before {
        animation: revealLTR 1.8s ease;
      }

      &:after {
        animation: revealLTR 1s .6s ease;
      }
    }

    &.animation-rtl.animate-in {
      &:before {
        animation: revealRTL 1.8s ease;
      }

      &:after {
        animation: revealRTL 1s .6s ease;
      }
    }
  }

  @keyframes revealRTL {
    0% {
      width: 0;
      right: 0;
    }

    65% {
      width: 100%;
      right: 0;
    }

    100% {
      width: 0;
      right: 100%;
    }
  }

  @keyframes revealLTR {
    0% {
      width: 0;
      left: 0;
    }

    65% {
      width: 100%;
      left: 0;
    }

    100% {
      width: 0;
      left: 100%;
    }
  }


  @keyframes textHidden {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }


  // ---------------------------------------------------------
  // module
  // ---------------------------------------------------------
  .flex {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flexbox;
    display: -moz-flexbox;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: -moz-flex;
    -js-display: flex;
    display: flex;
  }

  .center-x {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .center-y {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .between {
    justify-content: space-between;
  }

  .align-center {
    align-self: center;
  }

  .justify-center {
    justify-content: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
  }

  .column {
    flex-direction: column;
  }

  .justify-between {
    justify-content: space-between;
  }

  .push-r {
    margin-right: auto;
  }

  .ellipsis {
    position: relative;
    height: 3em;
    overflow: hidden;
    line-height: 1.5em;

    &:before {
      content: "･･";
      bottom: 0;
      right: 0;
    }

    &:after {
      content: "";
      width: 100%;
      height: 100%;
    }

    &:before,
    &:after {
      position: absolute;
      background: #fff;
    }
  }

  .boxLink {
    cursor: pointer;
    position: relative;
    z-index: 2;

    &:hover {
      opacity: 0.7;
    }
  }

  .cf {
    zoom: 1;

    &:after {
      content: "";
      display: table;
      clear: both;
      visibility: hidden;
    }
  }

  .table_base {
    width: 96%;
    margin-right: auto;
    margin-left: auto;
    border-top: 1px solid #D2BE50;
    border-bottom: 1px solid #D2BE50;
    tr {
      display: block;
      width: 100%;
      &:not(:last-child) {
        border-bottom: 1px solid #D2BE50;
      }
    }
    th,
    td {
      padding: 3.0% 1% 2.6%;
      //
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5;
      letter-spacing: .05em;
      text-align: justify;
      text-justify: inter-ideograph;
      //
      @media only screen and (max-width: 767px) {
        font-size: 13px;
      }
    }
    th {
      width: 18%;
      min-width: 118px;
      padding-left: 16px;
      color: #D2BE50;
      white-space: nowrap;
      //
      vertical-align: top;
      //
      @media only screen and (max-width: 767px) {
        min-width: 108px;
      }
      &.letter2 {
        letter-spacing: 2.3em;
      }
      &.letter3 {
        letter-spacing: .80em;
      }
      &.letter4 {
        letter-spacing: .26em;
      }
    }
    td {
      width: 82%;
      color: #fff;
      text-align: left;
      .text_table {
        display: block;
        margin-bottom: 3.0%;
        padding-bottom: 3.0%;
        border-bottom: 1px solid #D2BE50;
      }
      a {
        color: #fff;
      }
      &.adress {
        letter-spacing: -.06em;
      }
    }
  }
</style>

<script>
export default {
  name: 'LayoutDefault',
  data () {
    
    return {
      isActive01: false,
      isActive02: false,
      leftDrawerOpen: this.$q.platform.is.desktop,
      scrollPosition: null
    }
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    }
  },

  mounted: function () {
    window.addEventListener('scroll', this.updateScroll);

    this.$nextTick(function () {
      // ビュー全体がレンダリングされた後にのみ実行されるコード
      document.onscroll = () => {
        this.position = document.documentElement.scrollTop || document.body.scrollTop;
      }
    })
  }
}
</script>
